import React from 'react';
import { Container, Paper, Typography } from '@mui/material';

const FAQ = () => {
  const faqs = [
    {
      question: 'How do I change my shipping address?',
      answer: 'Please email any address changes to your Logistics Analyst contact.',
    },
    {
      question: 'When can I place my order for next month?',
      answer: 'You can start placing your orders for the next month beginning on the 6th business day of the previous month, up through the 5th business day of the next month. For example, you can create your order that ships in December on October 8th and it can be edited as many times as you want until the 5th business day of November which would be the 7th.',
    },
    {
      question: 'Can I revise my order after submitting?',
      answer: 'You can continuously revise your order up until midnight of the 5th business day of each month. After midnight, your order will be locked from editing. You will then need to contact your Logistics Analyst by e-mail or phone to make a change',
    },
  ];

  return (
    <div style={{ backgroundColor: '#e3e3e3', minHeight: '600px', padding: '32px 0' }}>
      <Container maxWidth="md">
        {faqs.map((faq, index) => (
          <Paper key={index} elevation={3} style={{ marginBottom: '16px', padding: '16px' }}>
            <Typography variant="h6" gutterBottom style={{ borderBottom: 'solid 1px black', paddingBottom: '8px' }}>
              {faq.question}
            </Typography>
            <Typography variant="body1" style={{ fontFamily: "'Didact Gothic', sans-serif" }}>
              {faq.answer}
            </Typography>
          </Paper>
        ))}
        
        <Paper elevation={3} style={{ marginTop: '32px', padding: '16px' }}>
          <Typography variant="h6" gutterBottom style={{ borderBottom: 'solid 1px black', paddingBottom: '8px' }}>
            Sales Terms
          </Typography>
          <Typography variant="body2" paragraph>
            <strong><u>Please review your order carefully before submitting it.</u></strong><br /> Your order submission represents a binding commitment to purchase Duvel USA products.
          </Typography>
          <Typography variant="body2" paragraph>
            Orders are due by the 5th business day of each month to ship the following month. For example, an order shipping in January must be placed in the order portal by the 5th business day in December.
          </Typography>
          {/* Add the rest of the sales terms paragraphs here */}
        </Paper>
      </Container>
    </div>
  );
};

export default FAQ;